module.exports = __webpack_public_path__ + "8f2a2bf42b55002c6d84c3eb365e00d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desktop-logo-mercadopago.png
// module id = 1271
// module chunks = 0